import ServerStatusPage from './server-status-page';
 
export default ServerStatusPage;